if (!customElements.get('volume-confirm-modal')) {
  customElements.define('volume-confirm-modal', class VolumeConfirmModal extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.querySelector('.volume-confirm-modal__dialog');
      this.volumeEl = this.querySelector('[data-vc-volume]');
      this.confirmBtn = this.querySelector('[data-vc-confirm]');
      this.cancelEls = this.querySelectorAll('[data-vc-cancel]');
      this.boundKey = this.onKey.bind(this);

      this.confirmBtn.addEventListener('click', () => this.resolve(true));
      this.cancelEls.forEach((el) => el.addEventListener('click', () => this.resolve(false)));
    }

    confirm({ volume } = {}) {
      if (this._pending) return this._pending;
      if (this.volumeEl) this.volumeEl.textContent = volume || '';
      this._pending = new Promise((resolve) => {
        this._resolve = resolve;
        this.previouslyFocused = document.activeElement;
        this.removeAttribute('hidden');
        document.addEventListener('keydown', this.boundKey);
        if (typeof trapFocus === 'function') {
          trapFocus(this.dialog, this.confirmBtn);
        } else {
          setTimeout(() => this.confirmBtn && this.confirmBtn.focus(), 10);
        }
      });
      return this._pending;
    }

    resolve(value) {
      if (!this._resolve) return;
      const fn = this._resolve;
      this._resolve = null;
      this._pending = null;
      this.setAttribute('hidden', '');
      document.removeEventListener('keydown', this.boundKey);
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.previouslyFocused);
      } else if (this.previouslyFocused && this.previouslyFocused.focus) {
        try { this.previouslyFocused.focus(); } catch (e) { /* element may have been removed */ }
      }
      fn(value);
    }

    onKey(e) {
      if (e.key === 'Escape') this.resolve(false);
    }
  });

  window.requestVolumeConfirm = function ({ volume } = {}) {
    const el = document.querySelector('volume-confirm-modal');
    if (el && typeof el.confirm === 'function') return el.confirm({ volume });
    return Promise.resolve(
      window.confirm(`You are adding a ${volume}ml case to your cart. Would you like to proceed?`)
    );
  };

  // Boost AI Search & Filter (CLP/PLP) integration. Their product card uses an
  // inline onclick to call window.globalQuickAdd, bypassing our <product-form>.
  // We delegate clicks at the document capture phase, gate by the product's
  // volume tag (fetched lazily), then re-fire the click to let Boost run.
  (function gateBoostQuickAdd() {
    const cache = new Map();

    async function fetchVolume(handle) {
      if (cache.has(handle)) return cache.get(handle);
      try {
        let volume = null;
        const data = await fetch('/products/' + handle + '.js').then((r) => r.json());
        for (const t of (data && data.tags) || []) {
          const m = String(t).toLowerCase().match(/^volume:\s*(\d+)/);
          if (m) { volume = parseInt(m[1], 10); break; }
        }
        cache.set(handle, volume);
        return volume;
      } catch (e) {
        return null;
      }
    }

    document.addEventListener('click', async function (event) {
      const btn = event.target.closest && event.target.closest('button[onclick*="globalQuickAdd"]');
      if (!btn) return;
      if (btn.__vcConfirmed) {
        btn.__vcConfirmed = false;
        return;
      }

      const ancestorAnchor = btn.closest('a[href*="/products/"]');
      const card = btn.closest('.boost-sd__product-item, .boost-sd__product-list-item, .product-card, [data-product], article, li');
      const link = ancestorAnchor || (card && card.querySelector('a[href*="/products/"]'));
      if (!link) return;
      const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const volume = await fetchVolume(m[1]);
      if (Number.isFinite(volume) && volume < 750) {
        btn.setAttribute('aria-disabled', 'true');
        try {
          const proceed = await window.requestVolumeConfirm({ volume });
          if (!proceed) return;
        } finally {
          btn.removeAttribute('aria-disabled');
        }
      }

      btn.__vcConfirmed = true;
      btn.click();
    }, true);
  })();
}
